import { theme } from '@dojo/framework/core/middleware/theme';
import { create, v, w } from '@dojo/framework/core/vdom';
import { Accordion } from '@holmescorp/base-widgets/accordion2';
import { Icon } from '@holmescorp/base-widgets/icon';
import { difference, intersection } from '@holmescorp/collections';
import { createNlsMiddleware, keymap, lccstate, tapaneChangeProcess, viewEditProcess } from '@holmescorp/lcc-state';
import css from '../css/topicaccordion.m.css';
import { TopicsetBody } from './topicset-body';
import { TopicsetShortdesc } from './topicset-shortdesc';
const nls = createNlsMiddleware('settings');
const factory = create({ theme, nls, lccstate }).properties();
export const TopicAccordion2 = factory(({ properties, middleware: { theme, nls, lccstate } }) => {
    const { topic: { attributes = {}, children = [] } } = properties();
    const { key } = attributes;
    const { isPlaceholder, messages: { is_demo = false, demo_allowed_topics = '[]' } } = nls();
    if (isPlaceholder) {
        return null;
    }
    const { get, path } = lccstate;
    const expandKey = get(path('accordionSelected'));
    const keybase = new Set(expandKey);
    const keylocal = new Set();
    const themeCss = theme.classes(css);
    let allowed_topics = [];
    try {
        allowed_topics = JSON.parse(demo_allowed_topics);
    }
    catch (e) {
        console.warn(`json parse error ${e}`, demo_allowed_topics);
    }
    const kids = children
        .filter((val) => 'topicset' in val)
        .map((val) => {
        const { attributes = {}, children = [] } = val.topicset;
        const { title, key } = attributes;
        keylocal.add(key);
        const keyset = new Set(expandKey || []);
        const [, , rootpath] = keymap.get(key).path.split('/');
        const data = keymap.get(rootpath);
        const roottitle = data ? data.title : '';
        const useEyebrow = title !== roottitle;
        const openbutton = v('span', { classes: [themeCss.openCloseIcon] }, [w(Icon, { faname: 'angle-down' })]);
        const closebutton = v('span', { classes: [themeCss.openCloseIcon] }, [w(Icon, { faname: 'angle-up' })]);
        const statusbar = v('span', { classes: [themeCss.status] }, [w('TopicStatusIcon', { key })]);
        const lockIcon = v('span', { classes: [themeCss.lockIcon] }, [w(Icon, { faname: 'lock' })]);
        const opentitle = v('div', { classes: [] }, [
            v('span', {}, [is_demo && allowed_topics.indexOf(key) === -1 ? lockIcon : null, title]),
            statusbar,
            closebutton
        ]);
        const closedtitle = v('div', { classes: [] }, [
            v('span', {}, [is_demo && allowed_topics.indexOf(key) === -1 ? lockIcon : null, title]),
            statusbar,
            openbutton
        ]);
        const eyebrow = useEyebrow ? v('span', { classes: [themeCss.eyebrow] }, [roottitle]) : null;
        const titleopen = v('div', {}, [eyebrow, opentitle]);
        const titleclosed = v('div', {}, [
            eyebrow,
            closedtitle,
            w(TopicsetShortdesc, { key, kids: children, isOpen: false })
        ]);
        return {
            key,
            title: { open: titleopen, closed: titleclosed },
            content: w(TopicsetBody, { kids: children, key, isOpen: keyset.has(key) })
        };
    });
    return v('div', { classes: [themeCss.root], key, xqa: `topicaccordion ${key}` }, [
        w(Accordion, {
            openKeys: [...intersection(keybase, keylocal)],
            exclusive: true,
            headingLevel: 2,
            role: 'list',
            onOpenChanged: (keys) => {
                const { run } = lccstate;
                const keyset = [...difference(keybase, keylocal), ...Array.from(keys || [])];
                run(viewEditProcess)({ view: { params: { expandKey: keyset } } });
                run(tapaneChangeProcess)({ accordionSelected: keyset });
            }
        }, kids)
    ]);
});
